<!-- @format -->

<div class="cdialog overlay" style="width: 350px;">
  <div class="dialogHeader">
    <div mat-dialog-title>
      {{_common.cancel_booking}}
      

    </div>

    <div class="spacer"></div>
    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content class="max-height">
    <div class="max-scroll m-2">
      <form [formGroup]="form">
        <div class="text-center space-y-4">
          <!-- <div class="cardHeader"></div> -->
          <div class="space-y-2 mt-2 text-center">
            <div>
              <!-- {{_common.cancel_booking_confirm}} -->
              {{_common.cancel_booking_reason.reason}}
            </div>
            <div>
              <app-form-field class="w-full">
                <!-- <app-label>{{_common.cancel_booking_reason.reason}}</app-label> -->
                <mat-select formControlName="cancelReasonCode"
                  [placeholder]="_common.pls_select">
                  <mat-option [value]="cancelReasons.event_cancelled">
                    {{_common.cancel_booking_reason.event_cancelled}}
                  </mat-option>
                  <mat-option [value]="cancelReasons.incorrect_booking">
                    {{_common.cancel_booking_reason.incorrect_booking}}
                  </mat-option>
                  <mat-option [value]="cancelReasons.unexpected_matter">
                    {{_common.cancel_booking_reason.unexpected_matter}}
                  </mat-option>
                  <mat-option [value]="cancelReasons.other_location">
                    {{_common.cancel_booking_reason.other_location}}
                  </mat-option>
                  <mat-option [value]="cancelReasons.other">
                    {{_common.cancel_booking_reason.other}}
                  </mat-option>
                </mat-select>

              </app-form-field>
            </div>
            <div *ngIf="form.value.cancelReasonCode==cancelReasons.other">
              <app-form-field class="w-full">
                <input matInput formControlName="cancelReason" [placeholder]="_common.cancel_booking_reason.other_reason"/>
              </app-form-field>
            </div>
          </div>


        </div>
      </form>
      <div class="flex justify-center m-4">
        <button class="client_button" (click)="save()" color="primary">
          {{_common.confirm}}
        </button>
      </div>

    </div>
  </mat-dialog-content>
  <!-- <div class="dialogBar">
    <div class="spacer"></div>


  </div> -->
</div>